import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import AuthShell from "@/components/AuthShell";

export default function NotFound({ inApp }) {
  const body = (
    <div data-testid="not-found" className="mpl-card flex flex-col items-start gap-3 p-6">
      <Compass className="text-[#B7F52A]" size={26} />
      <p className="text-sm text-slate-300">Cette page n'existe pas ou vous n'y avez pas accès.</p>
      <Link to={inApp ? "/tableau-de-bord" : "/"} className="mpl-btn-primary" data-testid="not-found-home">Retour à l'accueil</Link>
    </div>
  );
  if (inApp) return <div className="pt-6"><h1 className="mb-6 font-display text-4xl font-extrabold uppercase">Page introuvable</h1>{body}</div>;
  return <AuthShell title="Page introuvable">{body}</AuthShell>;
}
